import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from 'app/shared/services';
import 'rxjs/add/operator/finally';

@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
    constructor(private loaderService: LoaderService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.startLoading();
        return next.handle(request).finally(() => this.loaderService.stopLoading());
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/progress.interceptor.ts